import Vue from 'vue'
import Router from 'vue-router'
import index from '@/view/index'
import home from '@/view/home'
import aboutUs from '@/view/aboutUs'
import concat from '@/view/concat'
import mediaCenter from '@/view/mediaCenter'
import notices from '@/view/notices'
import product from '@/view/product'
import cases from '@/view/case'
import services from '@/view/services'
import news from '@/view/news'
import honor from '@/view/honor'
import corporate from '@/view/corporateCulture';
import academic from '@/view/academicTrends/academic';
import videoLive from '@/view/academicTrends/video';
import academicMeet from '@/view/academicTrends/academicMeet'
import responsibility from '@/view/responsibility';
import concept from '@/view/invite/concept';
import recruitment from '@/view/invite/recruitment';
import development from '@/view/invite/development';
import article from '@/view/article/index'
import detail from '@/view/product/detail'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'index',
      component: index,
      redirect: '/home',
      children: [{
          path: '/home',
          name: 'home',
          component: home,
        },
        {
          path: '/about',
          name: 'about',
          component: aboutUs,
        },
       
        // // 联系我们
        // {
        //   path: '/concat',
        //   name: 'concat',
        //   component: concat,
        // },
        // //媒体中心
        // {
        //   path: '/mediaCenter',
        //   name: 'mediaCenter',
        //   component: mediaCenter,
        // },
        // // 公司通告
        // {
        //   path: '/notices',
        //   name: 'notices',
        //   component: notices,
        // },
        
        // //产品
        // {
        //   path: '/product',
        //   name: 'product',
        //   component: product,
        // },
        // //服务
        // {
        //   path: '/services',
        //   name: 'services',
        //   component: services,
        // },
        //案例
        {
          path: '/cases',
          name: 'cases',
          component: cases,
        },
        //新闻 企业 行业资讯
        {
          path:'/news',
          name:'news',
          component:news,
        },
         //资质荣誉
         {
          path: '/honor',
          name: 'honor',
          component: honor,
        },
        //资质荣誉
        {
          path: '/corporate',
          name: 'corporate',
          component: corporate,
        },
         //学术直播
        {
          path: '/academic',
          name: 'academic',
          component: academic,
        }, //视频直播
        {
          path: '/video',
          name: 'videoLive',
          component: videoLive,
        },
        {
          path: '/academicMeet',
          name: 'academicMeet',
          component: academicMeet,
        },//学术沙龙会
        
        //企业社会责任
        {
          path: '/responsibility',
          name: 'responsibility',
          component: responsibility,
        },
        //人才理念
        {
          path: '/concept',
          name: 'concept',
          component: concept,
        },
        //人才招聘
        {
          path: '/recruitment',
          name: 'recruitment',
          component: recruitment,
        },
        //人才发展
        {
          path: '/development',
          name: 'development',
          component: development,
        },
         //文章详情
         {
          path: '/article',
          name: 'article',
          component: article,
        },
        //产品详情
        {
         path: '/detail',
         name: 'detail',
         component: detail,
       },
        
        
        
      ]
    },
    {
      path: '*',
      redirect: '/notfound'
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    console.log(to)
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
        offset: {
          y: 90
        }
      }
    }
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },

})
router.beforeEach((to, from, next) => {
  let path = to.path
  let len = path.length
  if (path.lastIndexOf('/') == len - 1) {
    path = path.substring(0, len - 1)
    next({
      path: path
    })
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js